import React from 'react';
import imageBadge from '../assets/images/licenseBaadge.png';

function BannerTemplate({
  title, description, bgImage, extraClass, isCertificates = false,
}) {
  const style = {
    backgroundImage: `url(${bgImage})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  };

  return (
    <div style={bgImage ? style : {}} className={['second_banner-main', extraClass].join(' ')}>
      <div className="second_banner-main-content">
        {!isCertificates && <h1 className="second_banner-title">{title}</h1>}
        {isCertificates && (
        <div className="title-with-image">
          <h1 className="second_banner-title">{title}</h1>
          <img src={imageBadge} alt="" />
        </div>
        )}
        <p className="second_banner-description">
          {description}
        </p>
      </div>
      {/* {!bgImage && <div className="magicpattern" />} */}
    </div>
  );
}

export default BannerTemplate;
